import none from '../../img/leoLogo.png'
import icedalango from '../../img/icecream/ice_dalagona.jpg'
import cakebastani from '../../img/icecream/cakebastani.jpg'

export const iceCream=[
    {
      "id": "171",
      "title": "بستنی شکلاتی لئو",
      "desciption": "",
      "price": "210",
      "image": none
    },
    // {
    //   "id": "172",
    //   "title": "بستنی عشق",
    //   "desciption": "بستنی توت فرنگی-خامه-چیزکیک",
    //   "price": "150",
    //   "image": none
    // },
    // {
    //   "id": "173",
    //   "title": "بستنی سنتی",
    //   "desciption": "",
    //   "price": "115",
    //   "image": none
    // },
    // {
    //   "id": "174",
    //   "title": "دسر ناپلئونی",
    //   "desciption": "شیرینی ناپلئونی-خامه-عسل",
    //   "price": "130",
    //   "image": none
    // },
    {
      "id": "175",
      "title": "کیک بستنی",
      "desciption": "",
      "price": "220",
      "image": cakebastani
    },
    // {
    //   "id": "176",
    //   "title": "کیک بستنی دونفره",
    //   "desciption": "",
    //   "price": "155",
    //   "image": none
    // },
   
    {
      "id": "178",
      "title": "ice dalgona",
      "desciption": " بستنی+نسکافه+کارامل",
      "price": "245",
      "image": icedalango
    },
    {
      "id": "179",
      "title": "وافل بستنی",
      "desciption": "",
      "price": "295",
      "image": icedalango
    },
    // {
    //   "id": "1710",
    //   "title": "وافل بستنی لئو",
    //   "desciption": "",
    //   "price": "260",
    //   "image": none
    // },
  ]